import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=0e861e9c&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"
import style0 from "./SetPassword.vue?vue&type=style&index=0&id=0e861e9c&prod&lang=scss&scoped=true"
import style1 from "./SetPassword.vue?vue&type=style&index=1&id=0e861e9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e861e9c",
  null
  
)

export default component.exports